import { useAtomValue } from 'jotai'
import { useResetAtom } from 'jotai/utils'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  ExecuteCancelDialog,
  type ExecuteCancelDialogProps,
} from '~/components/elements/ExecuteCancelDialog'

import { dialogInfoAtom } from '../atoms'
import { useCloseDialogWithRefresh } from '../hooks/useCloseDialogWithRefresh'
import { useDeleteBrandMutation } from '../hooks/useDeleteBrandMutation'

export const DeleteBrandDialog = () => {
  const { t } = useTranslation()
  const dialogInfo = useAtomValue(dialogInfoAtom)
  if (dialogInfo?.dialogType !== 'delete') {
    throw new Error()
  }
  const { brand } = dialogInfo

  const closeDialogWithRefresh = useCloseDialogWithRefresh()
  const deleteBrandMutation = useDeleteBrandMutation({
    onSuccess: closeDialogWithRefresh,
  })
  const handleExecute = React.useCallback<
    EH<ExecuteCancelDialogProps, 'onExecute'>
  >(() => {
    deleteBrandMutation.mutate(brand.id)
  }, [brand.id, deleteBrandMutation])

  const resetDialogInfo = useResetAtom(dialogInfoAtom)

  return (
    <ExecuteCancelDialog
      executing={deleteBrandMutation.isPending}
      mode="delete"
      title={t('delete_brand')}
      onCancel={resetDialogInfo}
      onExecute={handleExecute}
    >
      {t('delete_confirmation', { target: brand.name })}
    </ExecuteCancelDialog>
  )
}
